import styled from 'styled-components';
import { color } from 'styled-system';
import { pipe } from '../utils';
import { remapHoverProps, hoverFocus, focusVisibleStyle } from '../focus';
import Text from '../Text';
export var buttonBase = function buttonBase(props) {
  return {
    textStyle: props.large ? 'h6Medium' : 'bodyMedium',
    borderRadius: props.theme.radius,
    borderWidth: '1px',
    borderColor: 'currentColor',
    borderStyle: 'solid',
    textAlign: 'center',
    px: props.theme.button.paddingHorizontal,
    primary: props.theme.button.paddingHorizontal,
    lineHeight: props.large ? props.theme.button.heightLarge : props.theme.button.heightRegular,
    display: 'inline-block'
  };
}; // set the hover colors

export var hoverColor = pipe(remapHoverProps, color, hoverFocus);
export var InteractiveText = styled(Text).withConfig({
  displayName: "base__InteractiveText",
  componentId: "sc-cmy001-0"
})(focusVisibleStyle, hoverColor);